/* eslint-disable array-callback-return */
export function formatRut(rut, dots = false) {
  const current = rut.replace(/^0+/, '');

  if (current !== '' && current.length > 1) {
    const unformatRutvalue = unformatRut(current);
    const cleanRut = unformatRutvalue.substring(0, unformatRutvalue.length - 1);

    let rutNumberFormat = '';

    let i = 0;
    let j = 1;

    for (i = cleanRut.length - 1; i >= 0; i -= 1) {
      rutNumberFormat = cleanRut.charAt(i) + rutNumberFormat;
      if (j % 3 === 0 && j <= cleanRut.length - 1) {
        rutNumberFormat = (dots ? '.' : '') + rutNumberFormat;
      }
      j += 1;
    }

    let dv = unformatRutvalue.substring(unformatRutvalue.length - 1);
    rutNumberFormat = rutNumberFormat + '-' + dv;
    return rutNumberFormat.toUpperCase();
  }
  return current;
}

export function unformatRut(rut) {
  return rut ? `${rut}`.replace(/\./g, '').replace(/-/g, '') : rut;
}

export function validateRut(rut) {
  const cleanRut = unformatRut(rut);

  let body = cleanRut.slice(0, -1);
  let dv = cleanRut.slice(-1);

  if (body.length < 7) return false;

  let plus = 0;
  let multiple = 2;

  for (let i = 1; i <= body.length; i += 1) {
    plus += (multiple * cleanRut.charAt(body.length - i));
    if (multiple < 7) {
      multiple += 1;
    } else {
      multiple = 2;
    }
  }

  let dvAwait = 11 - (plus % 11);

  dv = (dv === 'K') ? 10 : dv;
  dv = (dv === 0) ? 11 : dv;
  dv = (dv === '0') ? 11 : dv;

  return dvAwait === +dv;
}

export function isValidFormatRut(rut) {
  let clean = (rut).replace(/[^0-9K]/g, '');
  return clean.length < 10;
}

export function getDvRut(rut) {
  const cleanRut = unformatRut(rut);
  let multiple = 2;
  let plus = 0;
  for (let i = 1; i <= cleanRut.length; i += 1) {
    plus += (multiple * cleanRut.charAt(cleanRut.length - i));
    if (multiple < 7) {
      multiple += 1;
    } else {
      multiple = 2;
    }
  }
  let dvAwait = 11 - (plus % 11);
  switch (dvAwait) {
    case 11:
      return '0';
    case 10:
      return 'K';
    default:
      return dvAwait.toString();
  }
}

export default {
  formatRut,
  unformatRut,
  validateRut,
  isValidFormatRut,
  getDvRut,
};
